window.initTranslateTooltip = function initTranslateTooltip() {
  var tooltipItems = document.querySelectorAll('span.translation-tooltip');

  tooltipItems.forEach(function(tooltip) {
    tooltip.setAttribute('translate', 'no');
  });

  // set alt text for parents of tooltipItems
  tooltipItems.forEach(function(tooltipItem) {
    titleText = $(tooltipItem).find('.translation-icon img').attr('title');

    $(tooltipItem).parent().attr('title', titleText);
  })

  var togleTooltip = function(e) {
    if (e.shiftKey) {
      tooltipItems.forEach(function(tooltipItem) {
        tooltipItem.parentElement.classList.add('show-translation');
      });
    } else {
      tooltipItems.forEach(function(tooltipItem) {
        tooltipItem.parentElement.classList.remove('show-translation');
      });
    }
  };
  
  $('body').on('keydown keyup keypress', function (e) {
    togleTooltip(e);
  });        
};

(function(w, d) {
  var docManager = {};

  docManager.options = {
    rlang: 'cs',
    rlangs: ['cpp', 'cs', 'usc'],
    rlangsMnemonics: {
      cpp: 'C++',
      cs: 'C#',
      usc: 'UnigineScript',
    },
    sortBy: 'none',
    viewBy: 'brief',
    prec: 'f',
  };

  if (initDocOptions) {
    for (var prop in initDocOptions) {
      if (initDocOptions.hasOwnProperty(prop)) {
        docManager.options[prop] = initDocOptions[prop]
      }
    }
  }

  docManager.getOptionsObject = function () {
    return this.options;
  };

  docManager.setOptionsObject = function (options) {
    return this.options = options;
  };

  function isNestedPropertyExist(obj, arrayOfKeys /*, level1, level2, ... levelN*/) {
    //var arrayOfKeys = Array.prototype.slice.call(arguments, 1);

    for (var i = 0; i < arrayOfKeys.length; i++) {
      if (!obj || !obj.hasOwnProperty(arrayOfKeys[i])) {
        return false;
      }
      obj = obj[arrayOfKeys[i]];
    }
    return true;
  }

  function getNestedPropertyIfExist(obj, arrayOfKeys) {
    for (var i = 0; i < arrayOfKeys.length; i++) {
      if (!obj || !obj.hasOwnProperty(arrayOfKeys[i])) {
        return false;
      }
      obj = obj[arrayOfKeys[i]];
    }
    return obj;
  }

  docManager.hasOption = function (optionName) {
    if (Array.isArray(optionName)) {
      return isNestedPropertyExist(this.options, optionName);
    }
    else {
      return this.options.hasOwnProperty(optionName);
    }
  };

  docManager.getOption = function (optionName) {
    if (Array.isArray(optionName)) {
      return getNestedPropertyIfExist(this.options, optionName);
    }
    else {
      return this.options[optionName];
    }
  };

  docManager.setOption = function (optionName, value) {
    return this.options[optionName] = value;
  };

  docManager.removeGetParameter = function(key, sourceURL) {
    var url = sourceURL || document.location.href;
    var urlparts= url.split('?');

    if (urlparts.length>=2)
    {
      var urlBase=urlparts.shift();
      var queryString=urlparts.join('?');

      var prefix = encodeURIComponent(key)+'=';
      var pars = queryString.split(/[&;]/g);
      for (var i= pars.length; i-->0;)
        if (pars[i].lastIndexOf(prefix, 0)!==-1)
          pars.splice(i, 1);
      url = urlBase+'?'+pars.join('&');
    }
    return url;
  };

  /*helpers*/
  docManager.clipboardInit = function () {
    var clipboard = new ClipboardJS('.btn-permalink', {
      target: function (trigger) {
        return trigger;
      },
      text: function (trigger) {
        var combineUrl = location.protocol + '//' +
          location.hostname + (location.port ? ':' + location.port : '') +
          location.pathname + location.search;
        //need to delete words parameter from buffer copied link
        return docManager.removeGetParameter('words', combineUrl) +
          trigger.getAttribute('data-clipboard-text');
      },
    });
    clipboard.on('success', function (e) {
      e.clearSelection();
    });
    clipboard.on('error', function (e) {
      console.log('Error clipboard copying:', e.action);
    });

    var btnElOrig = document.querySelector('.btn-copy-code');
    var btnEl;

    $('.documentation').find('.highlight-block-code').each(function () {
      if ($(this).hasClass('copy-off')) {
        return true;
      }
      btnEl = btnElOrig.cloneNode(true);

      btnEl.classList.remove('hide')
      btnEl.dataset.clipboardText = this.querySelector('pre code').textContent;
      this.prepend(btnEl);
    });

    var clipboardCode = new ClipboardJS('.btn-copy-code', {
      target: function (trigger) {
        return trigger;
      },
      text: function (trigger) {
        return trigger.getAttribute('data-clipboard-text');
      },
    });

    clipboardCode.on('success', function (e) {
      var clickedBtn = e.trigger;

      clickedBtn.classList.add('was-clicked')
      setTimeout(function () {
        clickedBtn.classList.remove('was-clicked')
      }, 2000)
      e.clearSelection();
    });

  }

  w.docManager = docManager;
  w.docOptions = docManager.options;

})(window, document);

$(function () {
  if (window.hljs) {
    window.hljs.initHighlighting();
  }

  var isInit = false;
  var treeRoot = $('.tree_root');
  var $searchHighlightBtn = $('.search-highlight-button');
  var $precSelectorBtn = $('.js-prec-selector-btn');
  var $documentationContainer = $('.documentation');
  var $currentPage = treeRoot.find('.current');

  var $langSelector = $('#lang-selector');
  var $langTitleTmpl = $langSelector.find('.lang-no-code-title');
  var $langWarning = $langSelector.find('.lang-warning');

  setTimeout(function () {
    initHistoryPopStateFix();
    window.Unigine.scrollToAddressHash();
    leftPanelScrollToSelect();
    highlightBtnInit();
  }, 300);

  function initHistoryPopStateFix() {
    //because history push state not triggered
    // we must recreate history for future ajax data loading by browser backward (Dev-805)
    // but we use ajax after first not ajax load
    var urlWithoutDomain = $(location).attr('href').replace($(location).attr('origin'), '');
    window.history.replaceState({href:urlWithoutDomain}, '',urlWithoutDomain);
  }

  /*Interface elements*/
  function highlightBtnInit() {
    var searchHighlight = $('.search-highlight');
    if (searchHighlight.length > 0) {
      $searchHighlightBtn.addClass('active');
      $searchHighlightBtn.removeClass('hide');

      $searchHighlightBtn.on('click', function() {
        $searchHighlightBtn.toggleClass('active');
        $documentationContainer.toggleClass('no-highlight');
      });

      $('body')[0].scrollTop = searchHighlight.position().top;
    }

    else {
      $searchHighlightBtn.removeClass('active');
      $searchHighlightBtn.addClass('hide');
    }
  }

  function docsOutdatedWarningInit() {
    var $docsOutdatedWarning = $('.js-docs-outdated-warning');
    if ($docsOutdatedWarning.length > 0) {
      $docsOutdatedWarning.find('i').on('click', function() {
        $docsOutdatedWarning.hide();
      });
    }
  }

  function docsUnsupportedWarningInit() {
    var $docsUnsupportedWarning = $('.js-docs-unsupported-warning');
    if ($docsUnsupportedWarning.length > 0) {
      $docsUnsupportedWarning.find('i').on('click', function() {
        $docsUnsupportedWarning.hide();
      });
    }
  }

  function precisionBtnInit() {
    var precTitles = $precSelectorBtn.attr('title').split('|');

    if (docManager.getOption('rlang') === 'cs') {
      $precSelectorBtn.removeClass('hide');
    }
    else if (docManager.getOption('rlang') === 'cpp' ||
      docManager.getOption('rlang') === 'usc') {
      $precSelectorBtn.addClass('hide');
    }

    if (!isInit) {
      var precDefault = window.Unigine.getCookie('prec');
      var precIsActive = precDefault === 'd';

      if (precIsActive) {
        $precSelectorBtn.addClass('active');
        $precSelectorBtn.attr('title', precTitles[0]);
      }
      else {
        $precSelectorBtn.removeClass('active');
        $precSelectorBtn.attr('title', precTitles[1]);
      }

      $precSelectorBtn.on('click', function(e) {
        $precSelectorBtn.toggleClass('active');
        precIsActive = !precIsActive;

        if (precIsActive) {
          $precSelectorBtn.attr('title', precTitles[0]);
          window.Unigine.setCookie('prec', 'd');
          docManager.setOption('prec', 'd');

        }
        else {
          $precSelectorBtn.attr('title', precTitles[1]);
          window.Unigine.setCookie('prec', 'f');
          docManager.setOption('prec', 'f');
        }

        tryToDynamicLoad(e, true);
      });
    }
  }

  function leftPanelScrollToSelect() {
    //var treeRootU = $('.tree_root');
    //var currentPageU = treeRootU.find('.current');

    var box = document.querySelector('.tree_root'),
        targetElm = box.querySelector('.current');

    scrollToElm(box, targetElm, 500);
  }

  function scrollToElm(container, elm, duration){
    //animation by jquery 180 its fixed header
    if ($(elm).length > 0) {
      $(container).animate({
        scrollTop: $(elm).offset().top - 180
      }, duration);
    }
  }

  function toggleTreeNode(element) {
    element.find('div.opened').removeClass('opened');
    element.toggleClass('opened');
  }

  function tagsInit() {
    var articlesTree = $('.articles-tree');
    var tagList = $('.tags-list');
    var articelTags = $('.article-tags');

    function toggleClasses() {
      var activeTags = [];
      tagList.find('li.active').each(function () {
        activeTags.push(this.className.replace('active', '').trim());
      });

      if (activeTags.length === 0) {
        articlesTree.removeClass('flat');
        articlesTree.find('> li').show();
        return;
      }

      articlesTree.find('> li').hide();
      articlesTree.addClass('flat');
      var classes = [];
      for (var tagIndex in activeTags) {
        classes.push(activeTags[tagIndex]);
      }

      articlesTree.find('> li.' + classes.join('.')).show();
    }

    if (tagList.length > 0) {
      tagList.find('li').click(function () {
        $(this).toggleClass('active');
        toggleClasses();
      });
      toggleClasses();

      articelTags.find('li').click(function () {
        tagList.find('li.' + this.className).click();
      });
    }
  }

  function sortBySelectInit() {
    var optValSort = window.Unigine.getCookie('sortBy');
    var $sortSelect = $('.sort-by select');
    var optValView = window.Unigine.getCookie('viewBy');
    var $viewSelect = $('.view-by select');

    if (optValSort) {
      $sortSelect.val(optValSort);
      docManager.setOption('sortBy', optValSort);
    }

    $sortSelect.on('change', function (event) {
      window.Unigine.setCookie('sortBy', $(this).val());
      docManager.setOption('sortBy', $(this).val());
      tryToDynamicLoad(event, true);
    });

    if (optValView) {
      $viewSelect.val(optValView);
      docManager.setOption('viewBy', optValView);
    }

    $viewSelect.on('change', function (event) {
      window.Unigine.setCookie('viewBy', $(this).val());
      docManager.setOption('viewBy', $(this).val());
      tryToDynamicLoad(event, true);
    });
  }

  function rlangWarningShow(replaceRlang, emptyRlang) {
    if (emptyRlang && docManager.hasOption(['rlangsMnemonics', emptyRlang])) {
      $langWarning.find('.no-lang').text(
        docManager.getOption(['rlangsMnemonics', emptyRlang])
      );
    }

    if (replaceRlang && docManager.hasOption(['rlangsMnemonics', replaceRlang])) {
      $langWarning.find('.lang-instead').text(
        docManager.getOption(['rlangsMnemonics', replaceRlang])
      );
    }
      
    $langWarning.show();

    if (!isInit) {
      $langWarning.find('i').on('click', function() {
        $langWarning.hide();
      });
    }
  }

  function rlangWarningHide() {
    $langWarning.hide();
  }

  function getRlangDefaultState() {
    return window.Unigine.getCookie('rlangDefaultState') || 'cpp';
  }

  function getRlangSearchParam() {
    return window.Unigine.getQueryParam('rlang');
  }

  function getSearchOrDefaultRlang() {
    var foundRlang = getRlangSearchParam();
    
    if (!foundRlang) {
      foundRlang = getRlangDefaultState();
    }

    return foundRlang;
  }

  function rlangSwitchInit(defaultRlang, rlangs) {
    var userRlang = getSearchOrDefaultRlang();

    if (defaultRlang && rlangs) {
      $langSelector.find('button').addClass('disabled-language');

      for (var i in rlangs) {
        $langSelector.find('button[data-rlang="' + rlangs[i] + '"]').removeClass('disabled-language').removeAttr('title');
      }

      //add title if no language exists
      $langSelector.find('button.disabled-language').each(function() {
        var dBtn = $(this),
            curRlang = dBtn.data('rlang'),
            curTitle = $langTitleTmpl.clone();

        curTitle.find('.no-lang').text(
          docManager.getOption('rlangsMnemonics')[curRlang]
        );

        dBtn.attr('title', curTitle.text().trim())
      });

      if (defaultRlang) {
        $langSelector.find('button').removeClass('current');
        $langSelector.find('button[data-rlang="' + defaultRlang + '"]').addClass('current');
        docManager.setOption('rlang', defaultRlang)

        if (rlangs.indexOf(userRlang) === -1) {
          rlangWarningShow(defaultRlang, userRlang);
        } else {
          rlangWarningHide();
        }
      }
      //show for ajax page loading
      $langSelector.show();
    } else {
      //hide for ajax page loading if page have not lang-selector
      $langSelector.hide();
      $precSelectorBtn.hide();
    }

    if (!isInit) {
      $langSelector.find('button').each(function () {
        var rlang = $(this).attr('data-rlang');
        $(this).click(function (e) {

          if ($(this).hasClass('disabled-language')) {
            e.preventDefault();
            return false;
          }

          window.Unigine.setCookie('rlangDefaultState', rlang);

          var search = decodeURIComponent(location.search.substr(1)).split('&'),
              newSearch = [],
              found = false;

          for (var searchPart in search) {
            if (!search.hasOwnProperty(searchPart)) {
              continue;
            }

            if (search[searchPart] === '') {
              continue;
            }

            if (search[searchPart].indexOf('rlang=') === 0) {
              newSearch.push('rlang=' + rlang);
              found = true;
              continue;
            }

            var split = search[searchPart].split('=');
            newSearch.push(split[0] + '=' + encodeURIComponent(split[1]));
          }

          if (!found) {
            newSearch.push('rlang=' + rlang);
          }

          window.location.search = newSearch.join('&');
        });
      });
    }
  }

  function getReadMoreObject() {
    var readMoreObj = window.Unigine.getCookie('readMoreState');

    try {
      readMoreObj = JSON.parse(readMoreObj);
    }
    catch (e) {
      console.log(e);
      return false
    }

    return readMoreObj;
  }

  function saveReadMoreState(instance, name, state) {
    var readMoreObj = getReadMoreObject() || {};

    if (!readMoreObj[instance]) {
      readMoreObj[instance] = {};
    }

    readMoreObj[instance][name] = state;
    if (!state) {
      delete readMoreObj[instance][name];
    }

    window.Unigine.setCookie('readMoreState', JSON.stringify(readMoreObj));
  }

  function getReadMoreState(instance, name) {
    var readMoreObj = getReadMoreObject();

    if (readMoreObj && readMoreObj[instance] && readMoreObj[instance][name]) {
      return readMoreObj[instance][name];
    }

    return false;
  }

  function readMoreInit(cb) {
    var readMorePath = window.location.pathname.slice(1).split('/').join('-');

    $('.read-more-methods').readmore({
      collapsedHeight: 80
    });

    $('.read-more-intro').readmore({
      collapsedHeight: 200,
      startOpen: getReadMoreState('read-more-intro', readMorePath),
      blockProcessed: function(element, expanded) {
        //add expanded class for stylish
        if(getReadMoreState('read-more-intro', readMorePath)) {
          $(element).addClass('is-expanded');
        }
      },
      beforeToggle: function(trigger, element, expanded) {
        saveReadMoreState('read-more-intro', readMorePath, !expanded);
        //add expanded class for stylish
        // !expanded because it is before state
        if(!expanded) {
          $(element).addClass('is-expanded');
        } else {
          $(element).removeClass('is-expanded');
        }
      },
      //bug in library after toogle call twice on opening
      afterToggle: function(trigger, element, expanded) {
        if(!expanded) {
          // The "Close" link was clicked
          $('html, body').animate( { scrollTop: element.offset().top }, {duration: 100} );
        }
      }
    });

    if (typeof cb === 'function') {
      cb();
    }
  }

  function readMoreRecalcHeight() {
    //HACK for spoiler inside "read more" dynamic height
    //cause it has resize trigger for "read more" height re-calc
    //https://github.com/jedfoster/Readmore.js/issues/144#issuecomment-218952415
    if (typeof (Event) === 'function') {
      // modern browsers
      window.dispatchEvent(new Event('resize'));
    } else {
      // for IE and other old browsers
      // causes deprecation warning on modern browsers
      var evt = window.document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    }
  }

  function subnavMenuInit() {
    var $subnavBtn = $('#subnav-button-menu').clone().removeAttr('id');
    var $subnavs = $('.documentation div.subnav');
    var $subnav = [];
    var scrollPosition = document.body.scrollTop +
      document.documentElement.scrollTop;
    var initState = window.Unigine.getCookie('subnavState') || 'opened';

    //get first subnav element without some excludes for backward compatibility
    $subnavs.each(function() {

      //if in subnav on page has '.list-of-functions' break cycle
      // cause this is old docs API section
      if ($(this).find('.list-of-functions').length > 0) {
        return false;
      }

      //if has no table inside subnav, get this subnav
      //(first on the page) and break cycle
      if (($(this).find('table').length <= 0)) {
        $subnav = $(this);
        return false;
      }
      else {
        return true;
      }
    });

    //hide subnav button for case if no subnav and page was ajax loaded
    $subnavBtn.addClass('hide');
    document.body.scrollTop = 0;
    document.getElementsByTagName('html')[0].scrollTop = 0;

    function hideMenu() {
      $subnav.addClass('closed');
      $subnavBtn.addClass('closed')
    }

    function showMenu() {
      $subnav.removeClass('closed');
      $subnavBtn.removeClass('closed');
    }

    function getMenuState($elm) {
      return $elm.hasClass('closed') ? 'closed' : 'opened';
    }

    function toggleMenu() {
      $subnav.toggleClass('closed');
      $subnavBtn.toggleClass('closed');
    }

    function addScrollStick($elm) {
      $(window).on('load resize scroll', function() {
        scrollPosition = document.body.scrollTop +
            document.documentElement.scrollTop;
        if (scrollPosition > 90) {
          $elm.addClass('stick-scroll');
        }
        else {
          $elm.removeClass('stick-scroll');
        }
      });
    }

    if ($subnav.length) {
      $subnavBtn.removeClass('hide');
      $subnav.prepend($subnavBtn);
      $subnav.addClass('floated');
      $subnav.addClass(initState);
      $subnavBtn.addClass(initState);

      $subnav.find('a').each(function() {
        var oldUrl = $(this).attr('href');
        var newUrl = '#'+oldUrl.split('#')[1];
        $(this).attr('href', newUrl);
      });

      addScrollStick($subnav);

      /*var menys = null;
      menys = new MenuSpy(document.querySelector('.documentation div.subnav > ul'), {
        threshold: 0,
        enableLocationHash: false
      });*/

      if ($(window).width() < 1800 && !window.Unigine.getCookie('subnavState')) {
        hideMenu();
      }
    }

    if (!isInit) {
      addScrollStick($subnavBtn);
    }

    $subnavBtn.off('click');
    $subnavBtn.on( 'click', function() {
      toggleMenu();
      window.Unigine.setCookie('subnavState', getMenuState($(this)));
    });
  }

  /*Ajax requests*/
  function getPage(href, success) {
    // if need forced ajax loading with rlang
    /*href = href.split('?')[0];
     href = href + '?rlang=' + getSearchOrDefaultRlang();*/

    curOpts = docManager.getOptionsObject();
    $.ajax({
      dataType: 'json',
      // we must build uniq url for ajax loading
      // cause backend has cache by url
      // and that's why all get params are passed
      url: '/' + window.currentLang
        + '/docs/getSingleArticle?path='
        + encodeURIComponent(href.replace('/docs', ''))
        + (curOpts['rlang'] ? '&rlang=' + curOpts['rlang'] : '')
        + (curOpts['prec'] ? '&prec=' + curOpts['prec'] : '')
        + (curOpts['sortBy'] ? '&sortBy=' + curOpts['sortBy'] : '')
        + (curOpts['viewBy'] ? '&viewBy=' + curOpts['viewBy'] : ''),
      success: function (text) {
        if (text === '') {
          return;
        }
        success(text);
      },
      complete: function (xhr, status) {
        if (xhr.status === 202) {
          var location = xhr.getResponseHeader('location');
          if (location) {
            document.location.href = location;
          }
        }
      },
      error: function (xhr, type, status) {
        success(xhr.responseText);
      }
    });
  }

  var urlregExp = '/(\\w+)/docs/([a-zA-Z0-9.]+)'
  var baseUrl = window.location.origin + (window.location.href).match(urlregExp)[0]
  var getCommentsregExp = new RegExp('<span class="hljs-comment">.*', "gm");

  function replaceAtIndex(_string, _index, _newValue) {
    if(_index > _string.length-1) 
      return string
    else
      return _string.substring(0,_index) + _newValue + _string.substring(_index+1)
  }

  $.expr[":"].icontains = $.expr.createPseudo(function(arg) {
    return function( elem ) {
        return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
    };
  });

  function isCamelCase(str) {
    var firstLetter = str.charAt(0)
    if ((firstLetter == firstLetter.toUpperCase()) && (/[A-Z]/.test(str))) {
      return true
    }
    else {
      return false
    }
  }

  var highlightedStringRegExp = new RegExp(/(⛏☮)?\${(.*?)#(.*?)HL(.*?)HL(.*?)#}(.*?)\$(<\/span>)?/gm);

  // get pre code html, containing HL word
  $( "pre code:icontains(HL)" ).html(function(i,html){
    // change line terminators to ⛏ and ☮
    var tempHtml = html.replaceAll(/\n/gm, "⛏").replaceAll(/\t/gm, "☮");
    // get raw strings that equal to regexp
    var rawHighlightedStrings = tempHtml.match(highlightedStringRegExp);
    // create tempHtml with ☺ instead found strings
    var tempHtml = tempHtml.replace(highlightedStringRegExp, "☺");

    var readyHtml = tempHtml;

    if (rawHighlightedStrings && rawHighlightedStrings !== 'null' && rawHighlightedStrings !== 'undefined') {
      var count = 0;
      for (var i = 0; i < rawHighlightedStrings.length; i++) {
        var ind = readyHtml.indexOf("☺", count)
        if (ind === -1) {
          break
        }
        var readyString = rawHighlightedStrings[i].replaceAll('HL','').replaceAll('#}$','').replaceAll('${','');
        var readyString = '<span style="background-color:#653306">' + readyString + '</span>';
        // changing ☺ to ready string by index in readyHtml
        var readyHtml = replaceAtIndex(readyHtml, ind, readyString)
        count++
      }
    }
    // return line terminators
    var readyHtml = readyHtml.replaceAll("⛏", '\n').replaceAll('☮', '\t');
    return readyHtml;
  })

  //initialization of links when you open site at first
  for (var j = 0; j < classes.length; j++) {
    var id = classes[j].id
    var path = classes[j].path
    $( "pre code:icontains('" + id + "')" ).html(function(i,html){
      var comments = html.match(getCommentsregExp)
      var regExp = new RegExp('(?<!<span class="hljs-keyword">using</span> )\\b(' + id + ')\\b', "gmi");
      var regExpPtr = new RegExp("\\b(" + id + "ptr" + ")\\b", "gmi");
      var regExpClassesCs = new RegExp('(?<= <span class="hljs-keyword">as</span> |		<span class="hljs-keyword">new</span> | <span class="hljs-keyword">new</span> | <span class="hljs-keyword">new</span>)\\b(' + id + ')\\b', "gmi");
    
      //replacing comments in code snippets with "☭"
      var replacedHtmlComments = html.replace(getCommentsregExp, "☭")

      var commonWords = replacedHtmlComments.match(regExp)

      //replacing words that are classes with "☢" and replacing Ptr classes with links
      var replacedHtmlWords = replacedHtmlComments
      .replace(regExp, '☢')
      .replace(regExpPtr, '<a href=' + baseUrl + path + '>$1</a>')

      //checking words to classes and replacing them with links, other just return
      if (commonWords && commonWords !== 'null' && commonWords !== 'undefined') {
        var count = 0
        for (var i = 0; i < commonWords.length; i++) {
          var ind = replacedHtmlWords.indexOf("☢", count)
          if (ind === -1) {
            break
          }
          if (isCamelCase(commonWords[i])) {
            var replacedHtmlWords = replaceAtIndex(replacedHtmlWords, ind, '<a href=' + baseUrl + path + '>' + commonWords[i] + '</a>')
          }
          else {
            var replacedHtmlWords = replaceAtIndex(replacedHtmlWords, ind, commonWords[i])
            var replacedHtmlWords = replacedHtmlWords.replace(regExpClassesCs, '<a href=' + baseUrl + path + '>$1</a>')
          }
          count++
        }
      }
      
      //return comments to code
      if (comments && comments !== 'null' && comments !== 'undefined') {
        var count = 0
        for (var i = 0; i < comments.length; i++) {
          var ind = replacedHtmlWords.indexOf("☭", count)
          var replacedHtmlWords = replaceAtIndex(replacedHtmlWords, ind, comments[i])
          count++
        }
      }
      return replacedHtmlWords
  }); 
  }

  function tryToDynamicLoad(event, sort) {
    var $currentTarget = $(event.target),
      href = window.location.pathname,
      title = '',
      $parentNode;

    if (event.button === 1) {
      return true;
    }

    if (!window.history.pushState) {
      return true;
    }

    event.preventDefault();
    event.stopPropagation();

    if (!sort) {
      $currentTarget = $(event.target);
      href = $currentTarget.attr('href');
      title = $currentTarget.attr('title');
    }
    $parentNode = $currentTarget.parent();

    if (window.location.pathname === href && sort !== true) {
      toggleTreeNode($parentNode);
      return;
    }

    getPage(href, function (response) {
      var baseTag = document.getElementsByTagName('base')[0];
      var yaLang = window.langSelector.yaTranslateGetLang();
      var isYaLangActive = window.langSelector.yaTranslateGetActive();
      var notTranslateDocForLangs = ['ch', 'ru'];

      if (isYaLangActive) {
        var queryString = href.split('?')[1];
        if (queryString) {
          href = href.split('?')[0] + '?' + window.Unigine.setQueryParam('autotranslate', yaLang, queryString);
        }
      }

      var realLocaleOfPage = window.Unigine.getCookie('realLocaleOfPage');

      if (notTranslateDocForLangs.indexOf(realLocaleOfPage) !== -1) {
        $('#doc').attr('translate', 'no');
        window.Unigine.setCookie('translateWarningHidden', 1, 5 * 24 * 60 * 60 * 1000);
        $('.js-translate-warning').addClass('hide');
      } else {
        $('#doc').removeAttr('translate');
        window.Unigine.deleteCookie('translateWarningHidden');
        $('.js-translate-warning').removeClass('hide');
      }

      baseTag.href = href;

      if (!sort) {
        $currentPage.toggleClass('current');
        $currentPage = $parentNode.addClass('current');

        document.title = response.title;
        window.history.pushState({'pageTitle': title, 'href': href}, '', href);
      }

      var content = $('#doc');
      content.html(response.doc);

      /*var classList = $('#content').attr('class').split(/\s+/);
       $.each(classList, function (index, item) {
       if (item !== 'documentation') {
       $('#content').removeClass(item);
       }
       });*/

      $('pre code').each(function (i, block) {
        hljs.highlightBlock(block);
      });

      // get pre code html, containing HL word
      $( "pre code:icontains(HL)" ).html(function(i,html){
        // change line terminators to ⛏ and ☮
        var tempHtml = html.replaceAll(/\n/gm, "⛏").replaceAll(/\t/gm, "☮");
        // get raw strings that equal to regexp
        var rawHighlightedStrings = tempHtml.match(highlightedStringRegExp);
        // create tempHtml with ☺ instead found strings
        var tempHtml = tempHtml.replace(highlightedStringRegExp, "☺");

        var readyHtml = tempHtml;

        if (rawHighlightedStrings && rawHighlightedStrings !== 'null' && rawHighlightedStrings !== 'undefined') {
          var count = 0;
          for (var i = 0; i < rawHighlightedStrings.length; i++) {
            var ind = readyHtml.indexOf("☺", count)
            if (ind === -1) {
              break
            }
            var readyString = rawHighlightedStrings[i].replaceAll('HL','').replaceAll('#}$','').replaceAll('${','');
            var readyString = '<span style="background-color:#653306">' + readyString + '</span>';
            // changing ☺ to ready string by index in readyHtml
            var readyHtml = replaceAtIndex(readyHtml, ind, readyString)
            count++
          }
        }
        // return line terminators
        var readyHtml = readyHtml.replaceAll("⛏", '\n').replaceAll('☮', '\t');
        return readyHtml;
      })

      //initialization of links when you go to another page
      for (var j = 0; j < classes.length; j++) {
        var id = classes[j].id
        var path = classes[j].path
        $( "pre code:icontains('" + id + "')" ).html(function(i,html){
          var comments = html.match(getCommentsregExp)
          var regExp = new RegExp('(?<!<span class="hljs-keyword">using</span> )\\b(' + id + ')\\b', "gmi");
          var regExpPtr = new RegExp("\\b(" + id + "ptr" + ")\\b", "gmi");
          var regExpClassesCs = new RegExp('(?<= <span class="hljs-keyword">as</span> |		<span class="hljs-keyword">new</span> | <span class="hljs-keyword">new</span> | <span class="hljs-keyword">new</span>)\\b(' + id + ')\\b', "gmi");
        
          //replacing comments in code snippets with "☭"
          var replacedHtmlComments = html.replace(getCommentsregExp, "☭")
    
          var commonWords = replacedHtmlComments.match(regExp)
    
          //replacing words that are classes with "☢" and replacing Ptr classes with links
          var replacedHtmlWords = replacedHtmlComments
          .replace(regExp, '☢')
          .replace(regExpPtr, '<a href=' + baseUrl + path + '>$1</a>')
    
          //checking words to classes and replacing them with links, other just return
          if (commonWords && commonWords !== 'null' && commonWords !== 'undefined') {
            var count = 0
            for (var i = 0; i < commonWords.length; i++) {
              var ind = replacedHtmlWords.indexOf("☢", count)
              if (ind === -1) {
                break
              }
              if (isCamelCase(commonWords[i])) {
                var replacedHtmlWords = replaceAtIndex(replacedHtmlWords, ind, '<a href=' + baseUrl + path + '>' + commonWords[i] + '</a>')
              }
              else {
                var replacedHtmlWords = replaceAtIndex(replacedHtmlWords, ind, commonWords[i])
                var replacedHtmlWords = replacedHtmlWords.replace(regExpClassesCs, '<a href=' + baseUrl + path + '>$1</a>')
              }
              count++
            }
          }
          
          //return comments to code
          if (comments && comments !== 'null' && comments !== 'undefined') {
            var count = 0
            for (var i = 0; i < comments.length; i++) {
              var ind = replacedHtmlWords.indexOf("☭", count)
              var replacedHtmlWords = replaceAtIndex(replacedHtmlWords, ind, comments[i])
              count++
            }
          }
          return replacedHtmlWords
      }); 
      }

      tagsInit();
      rlangSwitchInit(response.rlang, response.availableLangs);
      sortBySelectInit();
      readMoreInit(function () {
        readMoreRecalcHeight();
      });
      docManager.clipboardInit();
      highlightBtnInit();
      precisionBtnInit();
      window.feedback.init();
      window.juxtapose.scanPage();
      subnavMenuInit();
      if (typeof window.slider.init === 'function') {
        window.slider.init();
      }
      window.spoiler.init();
      //leftPanelScrollToSelect();
      window.Unigine.smoothScrollInit();
      window.Unigine.scrollToAddressHash();

      if ($documentationContainer.hasClass('has-translation-tooltip')) {
        window.initTranslateTooltip();
      }

      /*if (document.body.scrollTop + document.documentElement.scrollTop > 146) {
       document.body.scrollTop = 147;
       document.documentElement.scrollTop = 147;
       }*/

      $(window).scroll();
      if ($parentNode.hasClass('final')) {
        return;
      }

      $parentNode.addClass('opened');
    });
  }

  $(window).on('popstate', function (event) {
    var originalState = null;
    if (event.hasOwnProperty('state')) {
      originalState = event.state;
    } else if (event.hasOwnProperty('originalEvent')) {
      originalState = event.originalEvent.state;
    } else {
      return true;
    }

    if (originalState === null || originalState.href === '') {
      return true;
    }

    $currentPage.toggleClass('current');
    $currentPage = treeRoot.find('a[href="' + originalState.href + '"]').parent().addClass('current');

    var baseTag = document.getElementsByTagName('base')[0];
    baseTag.href = originalState.href;

    /*if (document.body.scrollTop + document.documentElement.scrollTop > 146) {
     document.body.scrollTop = 147;
     document.documentElement.scrollTop = 147;
     }*/

    getPage(originalState.href, function (text) {
      $('#doc').html(text.doc);
      document.title = text.title;

      $('pre code').each(function (i, block) {
        hljs.highlightBlock(block);
      });

      tagsInit();
      rlangSwitchInit();
      subnavMenuInit();
      window.slider.init();
    });
  });

  treeRoot.find('span.icon').click(function (event) {
    var evt = event || window.event; // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      evt.returnValue = false;
      evt.cancelBubble = true;
    }

    var parentDiv = $(event.target).parent().parent();
    toggleTreeNode(parentDiv);
  });

  treeRoot.find('a').not('.virtual').on('click', tryToDynamicLoad);

  tagsInit();
  sortBySelectInit();
  readMoreInit(function () {
    readMoreRecalcHeight();
    //window.Unigine.scrollToAddressHash();
  });
  docsOutdatedWarningInit();
  docsUnsupportedWarningInit();
  docManager.clipboardInit();
  window.feedback.init();
  window.spoiler.init();
  window.slider.init();
  precisionBtnInit();
  rlangSwitchInit(docManager.getOption('rlang') || '', docManager.getOption('rlangs') || []);
  subnavMenuInit();
  if ($documentationContainer.hasClass('has-translation-tooltip')) {
    window.initTranslateTooltip();
  }

  var leftPanelLinks = $('.js-left-panel-documentation .left-panel-menu a');
  var leftPanelLinksParent = $('.js-left-panel-documentation .left-panel-menu a').parent();
  
  leftPanelLinks.on('mouseenter', function (e) {
    $(this).parent().addClass('hover');

  });
  leftPanelLinks.on('mouseleave', function (e) {
    leftPanelLinksParent.removeClass('hover');
  });

  // hotfix huck: add classes to index-cards for gt
  var $indexCardsContainer = $('.index-items');

  if ($indexCardsContainer.length > 0) {
    $indexCardsContainer.children().each(function( i, element ) {
      $(element).addClass('gt-index-card');
      $(element).addClass('gt-index-card-' + i);
      switch (i) {
        case 0:
          $(element).addClass('gt-index-card-getting-started');
          break;
        case 1:
          $(element).addClass('gt-index-card-principles-of-operation');
          break;
        case 2:
          $(element).addClass('gt-index-card-tools');
          break;
        case 3:
          $(element).addClass('gt-index-card-programming');
          break;
        case 4:
          $(element).addClass('gt-index-card-api');
          break;
        case 5:
          $(element).addClass('gt-index-card-content-creation');
          break;
        default:
          break;
      }
    });
  }

  isInit = true;
});
